export const PERSONALINFO_NAME = "PERSONALINFO_NAME";
export const PERSONALINFO_BIRTHDATE = "PERSONALINFO_BIRTHDATE";
export const PERSONALINFO_EMAIL = "PERSONALINFO_EMAIL";
export const PERSONALINFO_PHONE = "PERSONALINFO_PHONE";
export const PERSONALINFO_ACCOUNTPASSWORD = "PERSONALINFO_ACCOUNTPASSWORD";

export const ADDRESS = "ADDRESS";
export const MAILINGADDRESS = "MAILINGADDRESS";

export const ADDRESS_MOVEINDATE = "ADDRESS_MOVEINDATE";
export const ADDRESS_HOUSINGSTATUS = "ADDRESS_HOUSINGSTATUS";

export const INCOMEEXPENSES_CREDITCARDS = "INCOMEEXPENSES_CREDITCARDS";
export const INCOMEEXPENSES_INCOME = "INCOMEEXPENSES_INCOME";
export const INCOMEEXPENSES_LOANS = "INCOMEEXPENSES_LOANS";
export const INCOMEEXPENSES_RENT = "INCOMEEXPENSES_RENT";
export const INCOMEEXPENSES_HOUSEHOLDINCOME = "INCOMEEXPENSES_HOUSEHOLDINCOME";
export const INCOMEEXPENSES_INVESTMENTINCOME = "INCOMEEXPENSES_INVESTMENTINCOME";

export const PERSONALINFO = "PERSONALINFO";
export const INCOMEEXPENSES = "INCOMEEXPENSES";
export const INCOMEFINANCES = "INCOMEFINANCES";
export const OCCUPATION = "OCCUPATION";
export const AUTHUSER = "AUTHUSER";


// WEBPACK FOOTER //
// ./src/utils/FieldTypes.js